var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 50,
    fill: "none",
    viewBox: "0 0 54 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    fillRule: "evenodd",
    d: "M53.4343 39.3362C53.5078 39.3362 53.5777 39.3688 53.6252 39.4239C53.6726 39.479 53.694 39.553 53.6838 39.626L53.6838 39.6264C53.6726 39.6937 52.9206 44.226 47.1772 44.226H6.50934C0.751685 44.226 0.009848 39.6719 0.00270514 39.626C-0.00800915 39.553 0.0134194 39.479 0.0613786 39.4239C0.109338 39.3683 0.178726 39.3362 0.252195 39.3362H53.4343ZM23.144 42.6311H30.542V40.9301H23.144V42.6311Z",
    clipRule: "evenodd",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    fillRule: "evenodd",
    d: "M49.3454 37.3362H4.34033V6.36377H49.3454V37.3362ZM45.774 9.9352H7.91176V33.7648H45.774V9.9352Z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.8d22b518e7768f7d63f11d5e51626900.svg";
export { ForwardRef as ReactComponent };